export type {
  RatingSlots,
  RatingBaseProps as RatingProps,
  RatingBaseState as RatingState,
  RatingContextValues,
} from '@fluentui/react-rating';
